import { Bone } from '../primitives';
import GenerationsTableSkeleton from '../GenerationsTableSkeleton';

// Matches the widget-card + GenerationsTable composite shared by Dubbing.js,
// VoiceChanger.js and VoiceIsolator.js — used for the hard-refresh case; each page's
// own in-app loading is already handled by GenerationsTable itself (see GenerationsTableSkeleton).
export default function GenerationsPageSkeleton({ columns = 2 }) {
    const gridTemplateColumns = ['1fr', ...Array.from({ length: columns }, () => '90px'), '70px'].join(' ');
    return (
        <div>
            <div style={{ border: '1px solid #E2E8F0', borderRadius: 13, padding: 20, marginBottom: 20 }}>
                <Bone h={14} w={160} style={{ marginBottom: 16 }} />
                <Bone h={90} r={10} style={{ marginBottom: 12 }} />
                <Bone h={38} w={140} r={9} />
            </div>
            <div style={{ border: '1px solid #E2E8F0', borderRadius: 16, overflow: 'hidden' }}>
                <GenerationsTableSkeleton gridTemplateColumns={gridTemplateColumns} rows={3} />
            </div>
        </div>
    );
}
